import { render, staticRenderFns } from "./BusinessComponent.vue?vue&type=template&id=74dc1c25"
import script from "./BusinessComponent.vue?vue&type=script&lang=js"
export * from "./BusinessComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports